import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteSubstitution } from 'src/store/actions/substitution-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { ISeance } from 'src/types/seance';

interface Props {
    data: ISeance;
}

const DeleteSubstitutionAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };
    return (
        <div>
            <button
                style={{ background: '#d3d3d3', color: '#1d1d1d' }}
                className="btn btn-secondary"
                type="button"
                onClick={() => setOpened(true)}
            >
                <FontAwesomeIcon icon={faTrash} /> substitution
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete session #{`"${id}"`}?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteSubstitution(id, handleClose, (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                }),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default DeleteSubstitutionAction;
